import {
    type CompanyProfile,
    type EmployeeRangeValue,
    type WorkCategory,
    type WorkCategoryLeaf,
    type WorkSubCategory,
} from '@houzy/schemas/partner-cockpit/company';

export type { WorkCategoryLeaf, WorkSubCategory, WorkCategory, CompanyProfile };

export type EmployeeRange = EmployeeRangeValue;

export const SETTINGS_TAB_IDS = [
    'company',
    'verification',
    'account',
    'members',
    'notifications',
    'subscription',
    'credits',
    'support',
] as const;
export type SettingsTabId = (typeof SETTINGS_TAB_IDS)[number];

export const PENDING_VALIDATION_SETTINGS_TAB_IDS = [
    'company',
    'verification',
    'account',
    'notifications',
    'support',
] as const satisfies readonly SettingsTabId[];

export type ContactDetails = {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
};

export type WorkRegion = {
    cantonIds: ReadonlySet<string>;
    postalCodes: ReadonlySet<string>;
};

export type Canton = {
    id: string;
    name: string;
};

export type CompanySettings = {
    profile: CompanyProfile;
    contact: ContactDetails;
    workCategoryLeafIds: ReadonlySet<string>;
    region: WorkRegion;
};
